import type { SVGProps } from 'react';
import React from 'react';

// import svg icons that will be used by Icon.tsx component here
import { ReactComponent as ChevronUp } from './arrows/components/chevron-up.svg';
import { ReactComponent as SyncIcon } from './arrows/synchronization.svg';
import { ReactComponent as HouseIcon } from './buildings/houseSvg.svg';
import { ReactComponent as UnitIcon } from './buildings/unit.svg';
import { ReactComponent as Analytics } from './graphsAndData/analytics.svg';
import { ReactComponent as PeopleIcon } from './human/people.svg';
import { ReactComponent as ThumbsDownIcon } from './human/thumbs-down.svg';
import { ReactComponent as ThumbsUpIcon } from './human/thumbs-up.svg';
import { ReactComponent as UserCardId } from './human/userCardId.svg';
import { ReactComponent as BedLightIcon } from './itemsAndObjects/bed_light.svg';
import { ReactComponent as CreditCardIcon } from './itemsAndObjects/creditCard.svg';
import { ReactComponent as Mail } from './itemsAndObjects/mail-icon.svg';
import { ReactComponent as BucketIcon } from './office/bucket.svg';
import { ReactComponent as PencilIcon } from './office/pencil.svg';
import { ReactComponent as PlusIcon } from './operators/plus.svg';
import { ReactComponent as CrossmarkIcon } from './signsAndSymbols/CrossMark.svg';
import { ReactComponent as DragAndDropIcon } from './signsAndSymbols/dragAndDrop.svg';
import { ReactComponent as InlineMonth } from './signsAndSymbols/InlineMonth.svg';
import { ReactComponent as LayoutIcon } from './signsAndSymbols/LayoutIcon.svg';
import { ReactComponent as MoonIcon } from './space/moon.svg';
import { ReactComponent as StarFullIcon } from './space/star-full.svg';
import { ReactComponent as CalendarIcon } from './time/calendar.svg';
import { ReactComponent as TimeIcon } from './time/time.svg';

//arrows
export * from './arrows/components/ArrowRightIcon';
export * from './arrows/components/ArrowTopRight';
export * from './arrows/components/ChevronUpIcon';
export * from './arrows/components/DividerIcon';
export * from './arrows/components/DoubleChevronRight';
export * from './arrows/components/DoubleDivider';
export * from './arrows/components/LoaderIcon';
export * from './arrows/components/RotateIcon';

//buildings
export * from './buildings/components/HouseIcon';
//human
export * from './human/components/EyeOffIcon';
export * from './human/components/EyeOnIcon';
export * from './human/components/PeopleIcon';
export * from './human/components/PersonIcon';
export * from './human/components/PersonIconAdd';
export * from './human/components/PersonIconBig';
export * from './human/components/ThumbUpIcon';

//items and objects
export * from './itemsAndObjects/components/BellNotificationIcon';
export * from './itemsAndObjects/components/ChainIcon';
export * from './itemsAndObjects/components/CoffeeIcon';
export * from './itemsAndObjects/components/CompassIcon';
export * from './itemsAndObjects/components/FilterIcon';
export * from './itemsAndObjects/components/FilterWithArrowDownIcon';
export * from './itemsAndObjects/components/NotificationsListEmpty';
export * from './itemsAndObjects/components/RefreshIcon';
export * from './itemsAndObjects/mail.svg';
//office
export * from './office/components/ArchiveIcon';
export * from './office/components/ArrowLeftRight';
export * from './office/components/AttachmentIcon';
export * from './office/components/BookmarkIcon';
export * from './office/components/BucketIcon';
export * from './office/components/CalendarIcon';
export * from './office/components/Contract';
export * from './office/components/CopyIcon';
export * from './office/components/CreditCardIcon';
export * from './office/components/EmailIcon';
export * from './office/components/EmailIconOpen';
export * from './office/components/FileIcon';
export * from './office/components/GalleryImage';
export * from './office/components/ListIcon';
export * from './office/components/MessageCircle';
export * from './office/components/MonthInlineIcon';
export * from './office/components/MonthMultilineIcon';
export * from './office/components/MoveFolderIcon';
export * from './office/components/OfficeIcon';
export * from './office/components/OfficeIconMobile';
export * from './office/components/PdfIcon';
export * from './office/components/PencilIcon';
export * from './office/components/PhoneIcon';
export * from './office/components/PrintIcon';
export * from './office/components/ReservationsIcon';
export * from './office/components/SendIcon';
export * from './office/components/Settings';
export * from './office/components/SingleUnitIcon';
export * from './office/components/TagIcon';
export * from './office/components/Wallet';

//partners
export * from './partners/components';

//operators
export * from './operators/components/CirclePlusIcon';
export * from './operators/components/MinusIcon';
export * from './operators/components/PlusIcon';
//space
export * from './space/components/GlobeCrossedIcon';
export * from './space/components/GlobeIcon';
export * from './space/components/GlobeIconAlt';
export * from './space/components/MoonIcon';
export * from './space/components/StarIcon';
//time
export * from './time/components/ActivityLogIcon';
export * from './time/components/CalendarBlockedicon';
export * from './time/components/CalendarIcon2';
export * from './time/components/ClockIcon';
//signsAndSymbols
export * from './signsAndSymbols/BlockIcon';
export * from './signsAndSymbols/components/AdriagateIcon';
export * from './signsAndSymbols/components/AdriagateLogoIcon';
export * from './signsAndSymbols/components/AlertIcon';
export * from './signsAndSymbols/components/CheckIcon';
export * from './signsAndSymbols/components/CheckmarkIcon';
export * from './signsAndSymbols/components/CircleIcon';
export * from './signsAndSymbols/components/ColorIconAI';
export * from './signsAndSymbols/components/CrossmarkIcon';
export * from './signsAndSymbols/components/CrossWithCircleIcon';
export * from './signsAndSymbols/components/DownloadIcon';
export * from './signsAndSymbols/components/ExternalLink';
export * from './signsAndSymbols/components/GearIcon';
export * from './signsAndSymbols/components/GeniusIcon';
export * from './signsAndSymbols/components/HelpIcon';
export * from './signsAndSymbols/components/IconAI';
export * from './signsAndSymbols/components/InfoIcon';
export * from './signsAndSymbols/components/LogOutIcon';
export * from './signsAndSymbols/components/MapPinIcon';
export * from './signsAndSymbols/components/MenuIcon';
export * from './signsAndSymbols/components/MessageNotificationIcon';
export * from './signsAndSymbols/components/PauseIcon';
export * from './signsAndSymbols/components/PercentageIcon';
export * from './signsAndSymbols/components/PlayCircleIcon';
export * from './signsAndSymbols/components/PlayIcon';
export * from './signsAndSymbols/components/RadiationIcon';
export * from './signsAndSymbols/components/RentisticLogo';
export * from './signsAndSymbols/components/RepeatIcon';
export * from './signsAndSymbols/components/SearchIcon';
export * from './signsAndSymbols/components/StatusIcon';
export * from './signsAndSymbols/components/UploadIcon';
export * from './signsAndSymbols/components/VerticalDotsIcon';
export * from './signsAndSymbols/components/WhiteIconAI';

type IconConfig = {
  component: React.FunctionComponent<SVGProps<SVGSVGElement>>;
};

export type IconName =
  | 'house'
  | 'analytics'
  | 'mail'
  | 'chevronUp'
  | 'bucket'
  | 'pencil'
  | 'starFull'
  | 'thumbsUp'
  | 'thumbsDown'
  | 'layout'
  | 'inlineMonth'
  | 'crossmark'
  | 'calendar'
  | 'unit'
  | 'people'
  | 'dragAndDrop'
  | 'time'
  | 'plus'
  | 'moon'
  | 'synchronization'
  | 'creditCard'
  | 'bed_light'
  | 'userCardId';

export const svgIconsConfig: Record<IconName, IconConfig> = {
  house: { component: HouseIcon },
  analytics: { component: Analytics },
  mail: { component: Mail },
  chevronUp: { component: ChevronUp },
  bucket: { component: BucketIcon },
  pencil: { component: PencilIcon },
  starFull: { component: StarFullIcon },
  thumbsUp: { component: ThumbsUpIcon },
  thumbsDown: { component: ThumbsDownIcon },
  layout: { component: LayoutIcon },
  inlineMonth: { component: InlineMonth },
  crossmark: { component: CrossmarkIcon },
  calendar: { component: CalendarIcon },
  unit: { component: UnitIcon },
  people: { component: PeopleIcon },
  dragAndDrop: { component: DragAndDropIcon },
  time: { component: TimeIcon },
  plus: { component: PlusIcon },
  moon: { component: MoonIcon },
  synchronization: { component: SyncIcon },
  creditCard: { component: CreditCardIcon },
  bed_light: { component: BedLightIcon },
  userCardId: { component: UserCardId },
};
